import script from "./ActionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionList.vue?vue&type=script&setup=true&lang=ts"

import "./ActionList.vue?vue&type=style&index=0&id=2f0d2906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0d2906"]])

export default __exports__